import React from "react"
import { Box } from "@infotech/uikit-grid"
import { DateRangePicker } from "@infotech/uikit-datepicker"

export default ({
  input: { value, onChange, name },
  meta: { error },
  withTime,
  typeOfDuration,
  duration,
}) => (
  <Box loose>
    <DateRangePicker
      onChange={value =>
        onChange([
          value[0] && value[0].getTime(),
          value[1] && value[1].getTime(),
        ])
      }
      name={name}
      typeOfDuration={typeOfDuration}
      duration={duration}
      value={[value[0] && new Date(value[0]), value[1] && new Date(value[1])]}
      withTime={withTime}
      error={error}
    />
  </Box>
)
